module.exports = __webpack_public_path__ + "img/pse.90699976.png";